module.exports = __webpack_public_path__ + "static/media/formulaKineticEnergy.dab34415.png";